import { IFRAME_SANDBOX_VALUE } from '../../constants/iframe';
import * as EVENTS from '../../constants/system-external-events';
import ENUMS from './enums';

const getThmIframe = () => document.getElementById('BTIframeID');

/**
 * constructThmIframeSrc
 * @param {string} orgId
 * @param {string} sessionId
 * @returns {string} iFrameSrc
 */
const constructThmIframeSrc = (orgId, sessionId) =>
  `${ENUMS.THM_URL_WITH_FP_TAG}org_id=${orgId}&session_id=${sessionId}`;

/**
 * Create iFrame for THM Profiling
 * @param {Object} dataObj
 * @param {Object} postMessage - (Optional) PostMessage object initiated by caller, used to track GTM event
 * @returns {HTMLIFrameElement}
 */
const initiateTHM = (dataObj, postMessage) => {
  const thmIframe = getThmIframe();
  // removing thm iframe and thm script tag if exists
  // as reloading an existing iFrame will introduce an unwanted browser history
  if (thmIframe) {
    const thmScriptId = document.getElementById(ENUMS.THM_SCRIPT_TAG_ID);
    thmScriptId.parentNode.removeChild(thmScriptId);
    thmIframe.parentNode.remove();
  }
  const orgId = dataObj.orgId; //StaticIdSingletonClass.orgId ? StaticIdSingletonClass.orgId : null; //get it from application
  const sessionId = dataObj.sessionId; //StaticIdSingletonClass.sessionId;
  const iFrameId = ENUMS.THM_IFRAME_ID;
  const iframe = document.createElement('iframe');
  const noscript = document.createElement('noscript');
  noscript.appendChild(iframe);
  document.body.appendChild(noscript);

  iframe.setAttribute('height', '100');
  iframe.setAttribute('width', '100');
  iframe.setAttribute('id', iFrameId); //THM_IFRAME_ID
  iframe.setAttribute('role', 'presentation');
  //set iFrame attributes
  iframe.setAttribute('src', constructThmIframeSrc(orgId, sessionId));
  iframe.setAttribute('data-tmxsession', sessionId);
  iframe.setAttribute(
    'style',
    'color:rgb(0,0,0); float:left; position:absolute; top:-400px; left:-400px; border:0;'
  );
  iframe.setAttribute('tabindex', '-1');
  iframe.setAttribute('title', 'For system use, please ignore');
  iframe.setAttribute('sandbox', IFRAME_SANDBOX_VALUE);
  //Do I need on static ids?
  //isThmiFrameLaunched(true); //set iFrame launch status as true
  //const isThmiFrameLaunched = true;
  //thmProfilingStartTime = Date.now();
  if (postMessage && postMessage.send && postMessage.send instanceof Function) {
    postMessage.send({ data: dataObj, type: EVENTS.SYS_THM_PROFILING_START });
  }

  return iframe;
};

export default initiateTHM;
